import apiService from '@/services/apiService';

const actions = {
  getTimeWIB({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.post('payment-aggregator-transaction-log/get-time-wib')
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getTransactionLogs({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('payment-aggregator-transaction-log/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getTransactionExport({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('payment-aggregator-transaction-log/find-without-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getTransactionLogID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`payment-aggregator-transaction-log/${payload}`)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  getMemberID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post(`additional-info/find-external-member-by-member-code`, payload)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  addRefund({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post(`payment-aggregator-transaction-log/refund`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getLockerCustomerInfo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`additional-info/locker/customer-info/${payload}`)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },

};

export default actions;
